//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos

import DemoChipColor from './demos/DemoChipColor.vue'
import DemoChipOutlined from './demos/DemoChipOutlined.vue'
import DemoChipLabel from './demos/DemoChipLabel.vue'
import DemoChipLight from './demos/DemoChipLight.vue'
import DemoChipClosable from './demos/DemoChipClosable.vue'
import DemoChipWithIcon from './demos/DemoChipWithIcon.vue'
import DemoChipPill from './demos/DemoChipPill.vue'
import DemoChipSizes from './demos/DemoChipSizes.vue'
import DemoChipExpandable from './demos/DemoChipExpandable.vue'
import DemoChipInSelects from './demos/DemoChipInSelects.vue'

// code
import {
  chipColor,
  chipOutlined,
  chipLabel,
  chipLight,
  chipClosable,
  chipWithIcon,
  chipPill,
  chipSizes,
  chipExpandable,
  chipInSelects,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoChipColor,
    DemoChipOutlined,
    DemoChipLabel,
    DemoChipLight,
    DemoChipClosable,
    DemoChipWithIcon,
    DemoChipPill,
    DemoChipSizes,
    DemoChipExpandable,
    DemoChipInSelects,
  },
  setup() {
    return {
      codeSnippets: {
        chipColor,
        chipOutlined,
        chipLabel,
        chipLight,
        chipClosable,
        chipWithIcon,
        chipPill,
        chipSizes,
        chipExpandable,
        chipInSelects,
      },
    }
  },
}
